import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const HeartUnlockShape = ({
  width = 36,
  height = 36,
  fillColor = 'none',
  style
}: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 25"
    fill={fillColor}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.94792 7.98958C7.94792 6.41632 8.40427 5.33647 9.1049 4.64841C9.80854 3.95737 10.8594 3.5625 12.2415 3.5625C13.9785 3.5625 15.2009 4.18148 15.8772 5.27537C16.104 5.64239 16.5854 5.75599 16.9525 5.52911C17.3195 5.30224 17.433 4.8208 17.2061 4.45379C16.1717 2.78019 14.3634 2 12.2415 2C10.566 2 9.07946 2.48341 8.01008 3.53359C6.9377 4.58675 6.38542 6.11106 6.38542 7.98958V8.29083C4.42296 9.01819 3 10.9826 3 13.3012C3 17.2995 6.09205 19.6058 8.72464 21.5696C8.99825 21.7736 9.26692 21.9741 9.52662 22.1723C10.5 22.9151 11.4375 23.6146 12.375 23.6146C13.3125 23.6146 14.25 22.9151 15.2233 22.1723C15.4831 21.9741 15.7518 21.7736 16.0254 21.5696C18.6579 19.6058 21.75 17.2995 21.75 13.3012C21.75 8.88746 16.5936 5.7573 12.375 10.0006C10.9276 8.54481 9.36993 7.95691 7.94792 7.99098V7.98958ZM12.375 12.4167C12.8065 12.4167 13.1562 12.7665 13.1562 13.1979V15.8021C13.1562 16.2335 12.8065 16.5833 12.375 16.5833C11.9435 16.5833 11.5938 16.2335 11.5938 15.8021V13.1979C11.5938 12.7665 11.9435 12.4167 12.375 12.4167Z"
      fill="white"
    />
  </svg>
);

export default HeartUnlockShape;
